import { render } from "./Home.vue?vue&type=template&id=56aee9e1"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=56aee9e1&lang=less"

import exportComponent from "/builds/fa4daba7/0/develop/front_payments_config/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__